import { render, staticRenderFns } from "./DailyHighlight.vue?vue&type=template&id=b20aadf4"
import script from "./DailyHighlight.vue?vue&type=script&lang=js"
export * from "./DailyHighlight.vue?vue&type=script&lang=js"
import style0 from "./DailyHighlight.vue?vue&type=style&index=0&id=b20aadf4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports